import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ExistCompanyGuard } from '@guards/exist-company.guard';

import { AccountSettingsOrganizationDetailsComponent } from '../organization/pages';

import {
  AccountSettingsBillingHistoryPageComponent,
  AccountSettingsCompanyDetailedComponent,
  AccountSettingsCompanyPageComponent,
  AccountSettingsOrganizationPageComponent,
  AccountSettingsUserDetailsPageComponent,
  AccountSettingsWrapperComponent,
  CompanyBondRequestEditPageComponent,
  CompanyBondRequestPageComponent,
  CompanyBondRequestResultPageComponent,
  CompanyBondRequestViewPageComponent,
  CompanyCbpAssignedNumberRequestApplicationPageComponent,
  CompanyCbpAssignedNumberRequestPageComponent,
  CompanyCbpAssignedNumberRequestStartPageComponent,
  CompanyCbpConnectionComponent,
  CompanyCreatePageComponent,
  PoaPurchaseComponent,
} from './pages';
import { ExistOrganizationGuard } from '@guards/exist-organization.guard';

const COMPANIES_ROUTES: Routes = [
  {
    path: 'account-settings',
    component: AccountSettingsWrapperComponent,
    children: [
      {
        path: 'company-view/:id/poa-purchase',
        component: PoaPurchaseComponent,
      },
      {
        path: 'user-details',
        component: AccountSettingsUserDetailsPageComponent,
      },
      {
        path: 'company-list',
        component: AccountSettingsCompanyPageComponent,
      },
      {
        path: 'create',
        component: CompanyCreatePageComponent,
      },
      {
        path: 'company-view/:id',
        component: AccountSettingsCompanyDetailedComponent,
      },
      {
        path: 'organization-view/:id',
        component: AccountSettingsOrganizationDetailsComponent,
      },
      {
        path: 'organization',
        component: AccountSettingsOrganizationPageComponent,
        canActivate: [ExistOrganizationGuard],
      },
      {
        path: 'billing-history',
        component: AccountSettingsBillingHistoryPageComponent,
        canActivate: [ExistOrganizationGuard],
      },
      { path: '**', redirectTo: 'organization' },
    ],
  },
  {
    path: 'cbp-assigned-number-request/:id',
    component: CompanyCbpAssignedNumberRequestPageComponent,
    canActivate: [ExistCompanyGuard],
    children: [
      {
        path: 'start',
        component: CompanyCbpAssignedNumberRequestStartPageComponent,
      },
      {
        path: 'application',
        component: CompanyCbpAssignedNumberRequestApplicationPageComponent,
        canActivate: [ExistCompanyGuard],
      },
      { path: '**', redirectTo: 'start' },
    ],
  },
  {
    path: 'self-filer',
    component: CompanyCbpConnectionComponent,
    canActivate: [ExistCompanyGuard],
  },
  {
    path: 'bond-request',
    component: CompanyBondRequestPageComponent,
    canActivate: [ExistCompanyGuard],
    children: [
      {
        path: 'edit',
        component: CompanyBondRequestEditPageComponent,
      },
      {
        path: 'view',
        component: CompanyBondRequestViewPageComponent,
      },
      {
        path: 'result',
        component: CompanyBondRequestResultPageComponent,
        data: {
          hideHeader: true,
        },
      },
      { path: '**', redirectTo: 'view' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(COMPANIES_ROUTES)],
  exports: [RouterModule],
})
export class CompanyRoutingModule {}
